import "./App.css";
import React, { lazy, Suspense } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { FaJsfiddle } from "react-icons/fa";

const Navbar = lazy(() => import("./components/Navbar"));
const Hero = lazy(() => import("./components/Hero"));
const Content = lazy(() => import("./components/Content"));
const Contact = lazy(() => import("./components/Contact"));

const renderLoader = () => (
  <div className="text-center min-h-screen bg-primary items-center flex place-content-center place-items-center mx-auto text-white">
    <FaJsfiddle />
    <span className="px-1">Processing...</span>
  </div>
);

// Greeting
const hour = new Date().getHours();
let greeting;
if (hour < 10) {
  greeting = "🌅 Good Morning, Dev";
} else if (hour < 14) {
  greeting = "🌤️ Good Day, Dev";
} else if (hour < 18) {
  greeting = "🌇 Good Afternoon, Dev";
} else {
  greeting = "🌙 Good Night, Dev";
}

// App.js use for diCoding.com Submission
console.log(greeting);

const App = () => (
  <Suspense fallback={renderLoader()}>
    <Navbar />

    <header id="top" className="w-full bg-white">
      <Hero />
    </header>
    <main id="main" role="main">
      <Content />
      <Contact />
    </main>

    <Link
      smooth
      to="#top"
      className=" w-8 h-10 rounded-sm bg-primary fixed bottom-5 right-5 place-items-center items-center mx-auto justify-center animate-none md:animate-bounce p-1"
    >
      <svg
        className="w-6 h-6 mx-auto place-content-center place-items-center items-center"
        fill="none"
        stroke="#fff"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 11l7-7 7 7M5 19l7-7 7 7"
        ></path>
      </svg>
    </Link>
  </Suspense>
);

export default App;

// import React from "react";
// import Webpages from "./blog";
// function App() {
//   return (
//     <div>
//       <Webpages />
//     </div>
//   );
// }
// export default App;



// WEBPACK FOOTER //
// ./src/App.js